import {
  IVitalListEmptyEntry,
  IVitalListEntry,
  TRecordConfig,
  TVitalDataResponse,
  TVitalDataSearchItem,
  TVitalSettingsResponse,
} from '../../../types/life-id';
import getGraphData from '../get-graph-data';
import { getDetailRowProps } from '../get-detail-row-props';
import getBadgeProps from '../get-badge-props';

/**
 *
 * @param vitalData
 * @param vitalDataSettings
 * @param config TRecordConfig
 */
export default function breathRateEntry(
  vitalData: TVitalDataResponse | null,
  vitalDataSettings: TVitalSettingsResponse | null,
  config: TRecordConfig,
): IVitalListEntry | IVitalListEmptyEntry {
  const emptyEntry: IVitalListEmptyEntry = {
    isEmpty: true,
    iconSrc: require('../../../assets/svg/life_id-breath-freq.svg').default,
    title: 'life_id.breath_frequency',
  };

  if (!vitalDataSettings || !vitalData || !vitalData.breathRate) {
    return emptyEntry;
  }

  const settings = [vitalDataSettings.breathRate];
  const lastRecord = vitalData.breathRate.lastRecord;

  return {
    ...emptyEntry,
    modalType: 'BREATHING_RATE' as const,
    isEmpty: false,
    average: vitalData.breathRate.average || '-',
    status: `life_id:status.${lastRecord.status}`,
    ...getBadgeProps(lastRecord.source),
    getDetailRowProps: getDetailRowProps(
      settings,
      config.BREATHING_RATE.valueSelectors[0] as keyof TVitalDataSearchItem,
    ),
    summaryChartProps: {
      oneSidedRange: false,
      unit: `units.${config.BREATHING_RATE.unit}`,
      value: lastRecord.breathRate || '-',
      ...getGraphData(settings, [lastRecord.breathRate]),
    },
    urlPart: config.BREATHING_RATE.urlPart,
  };
}
